export default __webpack_public_path__ + "static/media/cop.20336c4b.png";